import { Component, OnInit } from '@angular/core';
import { NavBarLink } from '../../type';

import { AdminService } from '../../../../service/admin.service';

import { DataSourceService } from '../../../../service/data-source.service';

@Component({
  selector: 'app-navbar-top',
  templateUrl: './navbar-top.component.html',
  styleUrls: ['navbar-top.component.scss'],
})
export class NavbarTopComponent implements OnInit {
  navbarTopLinks!: NavBarLink[];

  constructor(public adminService: AdminService, private datasourceService: DataSourceService) {}

  ngOnInit(): void {
    const navbarTopLinks = JSON.parse(JSON.stringify(this.datasourceService.s3Data.navBarSettings.navbarTop));
    navbarTopLinks.sort((a: NavBarLink, b: NavBarLink) => {
      return a.pos > b.pos ? 1 : -1;
    });
    this.navbarTopLinks = navbarTopLinks;
  }
}
